import { useFormikContext } from "formik";
import React from "react";
import { getName, labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import textFieldStyles from "../TextField/TextField.module.css";
import styles from "./Radio.module.css";

export default function Radio({ field_label, field_items, parent, isRequired }) {
  const name = getName(parent, field_label);
  return (
    <div className={textFieldStyles.inputContainer}>
      <label className={textFieldStyles.label}>{labelName(field_label)}{isRequired === "true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}</label>
      <div className={styles.checkContainer}>
        {field_items &&
          field_items.length > 0 &&
          field_items.map((item, index) => (
            <RadioInput key={`${item}-${index}`} title={item} name={name} />
          ))}
      </div>
      <ErrorMessage name={name} />
    </div>
  );
}

const RadioInput = ({ title, name }) => {
  const { setFieldValue } = useFormikContext();
  return (
    // <label className={styles.checkLabel}>
    //   <input
    //     type="radio"
    //     name={name}
    //     value={title}
    //     onChange={(e) => setFieldValue(name, e.target.value)}
    //   />
    //   <span>{title}</span>
    // </label>

    <label className={styles.container}>{title}
  <input type="radio"  value={title} onChange={(e) => setFieldValue(name, e.target.value)} name={name}/>
  <span className={styles.checkmark}></span>
</label>
  );
};
